export default __webpack_public_path__ + "static/media/extol.d4082ab8.png";